import {GET_ALL_DEDUCTION} from "../../constant/ActionType";

export default function PayrollDeduction(state = {
    deductionData:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case GET_ALL_DEDUCTION:
			return { ...state,
				deductionData: action?.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}







